module.exports = __webpack_public_path__ + "img/www.playstore.com.e0e911a0.png";